import React from "react";
import "./homeSections.css";

const FAQSection = () => {
  return (
    <section className="home-section faq-section">
      <div className="container">

        <h2>Frequently Asked Questions</h2>

        <div className="faq-item">
          <h3>1. What is ShareVideo?</h3>
          <p>
            ShareVideo is a multi-format content platform where users can upload
            videos, short clips, music content, audio songs, and photo posts.
            It allows creators to share their creativity and build an audience
            online.
          </p>
        </div>

        <div className="faq-item">
          <h3>2. What type of content can I upload?</h3>
          <p>
            You can upload full-length videos, short vertical videos (Shorts),
            music videos, standalone audio songs, and image-based photo posts.
            All content must follow our community guidelines and copyright policies.
          </p>
        </div>

        <div className="faq-item">
          <h3>3. How does monetization work?</h3>
          <p>
            ShareVideo offers an impression-based earning model. Creators can
            earn revenue based on the visibility and engagement their content
            receives. High-quality and original content performs better.
          </p>
        </div>

        <div className="faq-item">
          <h3>4. Is ShareVideo free to use?</h3>
          <p>
            Yes, creating an account and uploading content is free. Users can
            watch, listen, and explore content without subscription charges.
          </p>
        </div>

        <div className="faq-item">
          <h3>5. Are there content restrictions?</h3>
          <p>
            Yes. We do not allow copyrighted material without permission,
            harmful content, adult material, or policy-violating uploads.
            All content is subject to moderation.
          </p>
        </div>

        <div className="faq-item">
          <h3>6. How can I delete my account?</h3>
          <p>
            Users can request account deletion through the account settings
            section or by contacting our support team via the contact page.
          </p>
        </div>

      </div>
    </section>
  );
};

export default FAQSection;